import { Box, Button, Container, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import { useHearAbout } from "../../../common/hooks";
import { HookedForm } from "../../components/HookedForm";
import { HookedRadioGroup } from "../../components/HookedRadioGroup";
import { RoutePaths } from "../../consts/enums";
import { HookedField } from "../../components/HookedField";
import { useAppContext } from "../../../common/context/AppContext";
import { UserService } from "../../../common/services/UserService";
import { EventName, trackEvent } from "../../../common/utils/helpers";
import { UserType } from "../../../common/types";
import { useEffect } from "react";

export const Organisation = () => {
  const { user, updateUser } = useAppContext();
  const { data } = useHearAbout();
  const formHook = useForm();
  const navigate = useNavigate();

  const hearAboutOption = formHook.watch("hear_about_us");
  const handleContinue = async () => {
    const values = formHook.getValues();

    if (values.referred || values.other) {
      await UserService.SaveHearAboutUs(values.referred || values.other);
    }

    const res = await UserService.PatchUser(values);
    updateUser((prev) => ({
      ...prev,
      ...res,
    }));

    trackEvent(EventName.COMPLETED_BASIC);

    if (user.active_role === UserType.Buyer) {
      navigate(RoutePaths.REGISTER_ACQUIRER + "/specific");
    }
    if (user.active_role === UserType.Seller) {
      navigate(RoutePaths.REGISTER_SELLER + `/${res.startup_id}/basic`);
    }
  };

  useEffect(() => {
    if (!user.active_role) navigate(RoutePaths.REGISTER + "/basic");
  }, []);

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <HookedForm formHook={formHook}>
        <Container
          maxWidth="sm"
          sx={{
            paddingTop: 15,
            gap: 3,
            // padding: 5,
            display: "flex",
            flexDirection: "column",

            justifyContent: "center",
          }}
        >
          <Box>
            <Typography variant="h3" sx={{ marginBottom: 1 }}>
              How did you hear about us?
            </Typography>
          </Box>
          <HookedRadioGroup
            name="hear_about_us"
            options={data?.results.map((x) => ({
              label: x.display_name,
              value: x.id,
            }))}
          />
          {hearAboutOption &&
            data &&
            data.results &&
            data.results[
              data.results.findIndex((x) => x.id === hearAboutOption)
            ].display_name === "Other" && (
              <Box sx={{ marginTop: 2 }}>
                <HookedField
                  fullWidth
                  variant="filled"
                  component={TextField}
                  name="other"
                  placeholder="Type here"
                  hiddenLabel
                />
              </Box>
            )}
          {hearAboutOption &&
            data &&
            data.results &&
            data.results[
              data.results.findIndex((x) => x.id === hearAboutOption)
            ].display_name === "Referred" && (
              <Box sx={{ marginTop: 2 }}>
                <HookedField
                  fullWidth
                  variant="filled"
                  component={TextField}
                  name="referred"
                  placeholder="Who referred you? Please provide their full name."
                  hiddenLabel
                />
              </Box>
            )}
          <Box sx={{ width: "100%" }}>
            <Button
              variant="roundgradient"
              sx={{ backgroundColor: "common.lightgray" }}
              onClick={() => handleContinue()}
            >
              Continue
            </Button>
          </Box>
          <Typography variant="body2" color="common.gray">
            Clicking continue will register your Foundy account. You will now be
            taken to create your public listing anonymously and for free.
          </Typography>
        </Container>
      </HookedForm>
    </Box>
  );
};
